import React, {useState, useEffect } from "react";
import { exportLocations, fetchLocations } from '../../../modules/locations'
import { currentTime } from '../../../lib/datetime'

import LocationsSearch from './components/locations-search';
import LocationTable from "./components/location-table";

const initSearch = {
  name: "",
  city: "",
  address: "",
  state_code: "",
  chain_id: null,
  status: '',
  total: 0,
  perPage: 50,
  page: 1,
  init: false,
  sort_column: "id",
  sort_direction: "desc"
}

function Index() {
  const [locations, setLocations] = useState([]);
  const [key, setKey] = useState(0);
  const [query, setQuery] = useState(initSearch);

  useEffect(() => {
    if(query.init) return;
    search()
  }, [query]);

  function search() {
    fetchLocations(query).then((data) => {
      setLocations(data.result);
      setQuery({
        ...query,
        total: data.pagination.total,
        init: true,
      })
    });
  }

  function clearSearch() {
    setQuery(initSearch);
    setKey(prevKey => prevKey + 1);
  }

  function updateSearch(field, value) {
    setQuery({
      ...query,
      page: 1,
      init: false,
      [field]: value
    });
  }

  function updateSort(sort_column, sort_direction) {
    setQuery({
      ...query,
      init: false,
      sort_column,
      sort_direction,
    })
  }

  function submitSearch() {
    submit();
  }

  function updatePagination(page) {
    setQuery({
      ...query,
      init: false,
      page
    })
  }

  function handleExportLocations() {
    exportLocations(query)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `locations-${currentTime()}.csv`
        link.click();
        window.revokeObjectURL(url);
      })
  }

  return (
    <>
      <LocationsSearch
        query={query}
        submit={submitSearch}
        updateSearch={updateSearch}
        clearSearch={clearSearch}
        exportLocations={handleExportLocations}
        key={key}
      />
      <LocationTable
        locations={locations}
        query={query}
        updatePagination={updatePagination}
        updateSort={updateSort}
      />
    </>
  )
}


export default Index;